import script from "./FullScreenOverlay.vue?vue&type=script&lang=js"
export * from "./FullScreenOverlay.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__